export default {
  constants: {
    url_domain: '//contasiscorp.com',
    url_cuenta: 'https://cuenta.contasiscorp.com',
    url_micuenta: 'https://micuenta.contasiscorp.com',
    url_negocios: '//empresaonline.contasiscorp.com',
    url_negocios_api: 'https://a03fe350-f448-11ea-922e-690d037b3781.empresaonline.contasiscorp.com',
    url_negocios_api_contasis: 'https://b09bc530-153c-11ea-80b3-cfdcc8191422.empresaonline.contasiscorp.com',
    url_negocios_api_colegio: 'https://b4e69e20-ae3f-11ee-adec-79a92a165e15.empresaonline.contasiscorp.com',
    empresa_id_colegio: '471d1600-ae40-11ee-b5d2-5f2c0e779fc8',
    url_contasiscorp: '//compliance.contasiscorp.com',
    url_culqui: 'https://secure.culqi.com/v2/tokens',
    url_ayuda: '//soporte.contasiscorp.com',
    url_cpartner: 'https://cpartner-contasiscorp.com/portal/vistas/',
    domain: '.contasiscorp.com',
    publicKey: 'pk_live_16Ak4pDNT3pjttku',
    publicKeyCertified: 'pk_live_QKS1bgp4hbXriTEn',
    publicKeyIcode: 'pk_live_439f049c528f5f7a',
    plan_basico: 18,//21,18,
    plan_profesional: 19,//22,19,
    plan_experto: 20,//23,20,
    plan_ecommerce: 48,//32,30,
    plan_ecommerce_free: 32,//33,31,
    plan_vende_rapido: 47,
    plan_factura_instante: 32,
    izipay_endpoint: 'https://api.micuentaweb.pe',
    izipay_publickey: '86710468:publickey_FyN8qixix0ytc8SDE4scF7CH1E5Qq4zZsLbwgMWAha6U2',
    izipay_icode_publickey: '19304098:publickey_njzZaTd1iCjaEkKSCsPLrf5HMfFIAT3qa8AfT2DHwXTzC',
    izipay_publickey_contasiscorp: '75910738:publickey_QEnZIAX6oSaDxGOzG76HXmHUEyJbJeBJu3yyEVlymvBgP',
    tipo_documento_identidad_id: 'c71e5250-987b-11e9-b099-4bc7d5b5f72e',
    tipo_persona_id: 'c721ed80-987b-11e9-b028-7db5fde7ba20',
    tipo_entidad_tributaria_id: 'c902a5b0-987b-11e9-ab96-e754d7024dc7',
    url_admin_ccpll: 'https://admin-ccpll.org',
    url_admin_ccpll_front: 'https://admin.ccpll.org',
    compliance_plan: {
      free: 11,
      basico: 25,
      profesional: 26,
      experto: 27,
      pro: 39
    },
    gestion_plan: {
      free: 22
    },
    tipo_documento_identidad_id_dni: 'c71e5250-987b-11e9-b099-4bc7d5b5f72e',
    tipo_entidad_tributaria_id_dni: 'c902a5b0-987b-11e9-ab96-e754d7024dc7',
    tipo_persona_id_dni: 'c721ed80-987b-11e9-b028-7db5fde7ba20',
    empresa_id: '5cf34b60-1548-11ea-a119-49efe3efe32b',
    contasiscorp_empresa_id: '2400f950-15d2-11ea-b502-cb5f0d8a11a6', 
    contasissac_empresa_id: '5cf34b60-1548-11ea-a119-49efe3efe32b',
    tipo_documento_identidad_id_ruc: 'c71efd50-987b-11e9-80bc-b5750336f54f',
    tipo_entidad_tributaria_id_ruc: 'c902a5b0-987b-11e9-ab96-e754d7024dc7',
    tipo_persona_id_ruc: 'c7224df0-987b-11e9-a04a-c7ed4ce3c6e6',
    estado_contribuyente_id_ruc: 'c8ffd3e0-987b-11e9-bc54-a31e9b244d89',
  }
}